import React from 'react';
import Footer from './Footer/Footer';
import Navbar from './Navbar/Navbar';
import '../App.css';

const NotFound = () => {
    return (

        <>
        <Navbar/>
        <div className="centerednotfound">
            <p>Sarry, Page not found!</p>
        </div>
        <Footer/>
        </>
    );
};

export default NotFound;
